import { render, staticRenderFns } from "./couchImageryDbManagement.vue?vue&type=template&id=4dec790f"
import script from "./couchImageryDbManagement.vue?vue&type=script&lang=js"
export * from "./couchImageryDbManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports